import React from 'react';
import { ASSET_KEY, assetSource } from 'shared/utils/assetSource';
import styled, { createGlobalStyle } from 'styled-components';

const FavouritesEmpty = () => {
  return (
    <EmptyFavoritesContainer>
      <GlobalStyles />
      <EmptyFavoritesImage src={assetSource(ASSET_KEY.EMPTY_INFO)} alt="Empty Favourites" />
    </EmptyFavoritesContainer>
  );
};

export default FavouritesEmpty;

const EmptyFavoritesContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
  margin-top: 1rem;
  @media only screen and (max-width: 1300px) {
    margin-left: 15vw;
  }
`;

const GlobalStyles = createGlobalStyle`
  :root[data-pwa-mode='mobile-browser'] img.EmptyFavoritesImage {
    height: 45vh !important;
    margin-bottom: 5vh;
  }
`;

const EmptyFavoritesImage = styled.img`
  height: 55vh;
`;



